import { AgentDetailsProvider } from '../context';
import { NewFlowTemplatePickerPage } from './Page';

export function NewFlowTemplatePickerPageWithProvider() {
  return (
    <AgentDetailsProvider>
      <NewFlowTemplatePickerPage />
    </AgentDetailsProvider>
  );
}
